<div class="w-100 cash-register-session d-flex justify-content-center">
  <div class="row w-95">
    <div class="col-6 d-flex align-items-center" style="padding-left: 0;">
      <fa-icon class="circle-status" [icon]='faCircle'></fa-icon>
      <p style="margin: 0; font-size: 18px; font-weight: 400;">Caja activa: <span
          style="color: var(--color-primary);">{{cash_register_name}}</span> <span
          style="color: var(--color-gray); font-size: 14px;">
          | Sesión:
          {{cash_register_sesion_id}}</span></p>
    </div>
    <div class="col-6 d-flex justify-content-end align-items-center">
      <!-- Eventos (cuando estamos en abonos) -->
      <ng-container *ngIf="isPassSale">
        <fa-icon (click)="viewEvents()" style="color:var(--color-black); font-size: 18px; cursor: pointer;" [icon]='faEvents'></fa-icon>
        <p (click)="viewEvents()" class="black-link-text">Eventos</p>
      </ng-container>

      <!-- Abonos (cuando NO estamos en abonos y la org tiene abonos) -->
      <ng-container *ngIf="!isPassSale && hasPasses">
        <fa-icon (click)="viewPasses()" style="color:var(--color-black); font-size: 18px; cursor: pointer;" [icon]='faPasses'></fa-icon>
        <p (click)="viewPasses()" class="black-link-text">Abonos</p>
      </ng-container>

      <!-- Reservas / Eventos (cuando estamos en modo reserva mostramos Eventos) -->
      <ng-container *ngIf="!isReservationMode">
        <fa-icon (click)="viewReservas()" style="color:var(--color-black); font-size: 18px; cursor: pointer;" [icon]='faBookmark'></fa-icon>
        <p (click)="viewReservas()" class="black-link-text">Reservas</p>
      </ng-container>
      <ng-container *ngIf="isReservationMode">
        <fa-icon (click)="viewEvents()" style="color:var(--color-black); font-size: 18px; cursor: pointer;" [icon]='faEvents'></fa-icon>
        <p (click)="viewEvents()" class="black-link-text">Eventos</p>
      </ng-container>

      <!-- Devoluciones -->
      <fa-icon (click)="viewRefunds()" style="color:var(--color-black); font-size: 18px; cursor: pointer;" [icon]='faRefunds'></fa-icon>
      <p (click)="viewRefunds()" class="black-link-text">Devoluciones</p>

      <!-- Revisar caja -->
      <fa-icon (click)="viewReports()" style="color:var(--color-black); font-size: 18px; cursor: pointer;" [icon]='faReport'></fa-icon>
      <p (click)="viewReports()" class="black-link-text">Revisar caja</p>

      <!-- Ajustes -->
      <fa-icon (click)="openSettings()" class="gear-icon" [icon]="faGear"></fa-icon>
    </div>
  </div>
</div>
